export default "__VITE_ASSET__DShe$Rmo__"